import { Easing } from './easing';
import { AnimateOptions } from './types';

export const defaultAnimateOptions: Required<AnimateOptions> = {
  duration: 200,
  easing: Easing.Linear,
  forceRedraw: false,
  reversible: false,
  runCount: 1,
};
